<template>
  <div class="overlay">
    <div class="widget-modal-widget" :id="'sideBar' + $store.state.sidebar">
      <div class="widget-modal-header">
        <h1 v-if="title" class="title">{{ title }}</h1>
        <h3 v-if="subtitle" class="sub-title">{{ subtitle }}</h3>
      </div>
      <slot></slot>
      <div class="widget-modal-footer" v-if="!footerhidden">
        <div class="modal-left-option">
          <b-button type="is-primary" @click="onLeftClick" :loading="leftloading">
            {{ btnrighttext }}
          </b-button>
        </div>

        <div class="modal-right-option">
          <b-button type="is-primary" @click="onRightClick" :loading="rightloading" outlined>
            {{ btnlefttext }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget_button",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    btnlefttext: {
      type: String,
      default: "Cancel",
    },
    btnrighttext: {
      type: String,
      default: "Ok",
    },
    leftloading: {
      type: Boolean,
      default: false,
    },
    rightloading: {
      type: Boolean,
      default: false,
    },
    footerhidden: {
      type: Boolean,
      default: false,
    },
    cornericon: {
      type: String,
      default: "",
    },
    // width: {
    //   type: String,
    //   default: "500px",
    // },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() { },
  methods: {
    onClose() {
      let vm = this;
      vm.$emit("onClose", null);
    },
    onLeftClick() {
      let vm = this;
      vm.$emit("onLeftClick", null);
    },
    onRightClick() {
      let vm = this;
      vm.$emit("onRightClick", null);
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 999;
  background: rgba($color: #000000, $alpha: 0.5);
  display: block;
  padding-top: 100px;
  overflow-y: auto;
  z-index: 9999999;

  @media (max-width: 500px) {
    padding-top: 60px;
  }

  .widget-modal-widget {
    margin: 0 auto;
    width: 500px;
    background: #fff;
    padding: 30px;
    border-radius: 5px;
    margin-bottom: 100px;
    position: relative;
    transition: .6s;

    @media (max-width: 570px) {
      width: 90%;
    }
    @media (max-width: 500px) {
      width: 100%;
      margin-bottom: 0;
    }

    .btn-close {
      position: absolute;
      top: -15px;
      right: -12px;
      width: 44px;
      height: 44px;
      background: #ffdcdc;
      border: none;
      border-radius: 50%;
      font-size: 28px;
      color: #ff0000;
      cursor: pointer;
      z-index: 99;

      &:hover {
        opacity: 0.9;
      }
    }

    .corner-icon {
      position: absolute;
      top: 0px;
      right: 0px;
      width: 100px;
      height: 100px;
    }

    .widget-modal-header {
      margin-bottom: 20px;

      .title {
        font-size: 20px;
        margin-bottom: 7px;
        color: #183b56;
      }

      .sub-title {
        font-size: 14px;
        margin-bottom: 10px;
        color: #0f2f64;
      }
    }

    .widget-modal-body {
      height: 400px;
      overflow-y: auto;
    }

    .widget-modal-footer {
      padding: 10px 0px;
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
    }
  }
}

#sideBartrue {
  left: 100px;

  @media (max-width: 768px) {
    left: 0;
  }
}
</style>
